import { feedItems } from "@/mocks/data";

const iconOf = (phase: string) => {
  if (phase.includes("通勤")) return "ri-sun-line";
  if (phase.includes("蹲更") || phase.includes("追更")) return "ri-refresh-line";
  if (phase.includes("午间")) return "ri-cup-line";
  if (phase.includes("黄金")) return "ri-moon-clear-line";
  if (phase.includes("睡前")) return "ri-moon-line";
  return "ri-flashlight-line";
};

const colorOf = (phase: string) => {
  if (phase.includes("通勤")) return "bg-accent-100 text-accent-700";
  if (phase.includes("午间")) return "bg-secondary-100 text-secondary-700";
  if (phase.includes("睡前")) return "bg-primary-100 text-primary-700";
  return "bg-background-200 text-foreground-700";
};

export default function Schedule() {
  return (
    <section id="schedule" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <div className="mb-3 text-sm font-medium text-primary-600">
            <i className="ri-calendar-check-line mr-2"></i>
            每日瓜历
          </div>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">
            把吃瓜排进一天的节奏里
          </h2>
          <p className="mt-4 text-sm text-foreground-600 md:text-base">
            从通勤到睡前,每个时段都有对应的瓜报与刷新提醒,养成习惯再也不靠硬撑。
          </p>
        </div>

        <div className="relative mx-auto mt-12 max-w-4xl">
          <div
            aria-hidden="true"
            className="absolute left-5 top-0 h-full w-0.5 bg-gradient-to-b from-accent-300 via-secondary-300 to-primary-300 md:left-1/2"
          ></div>
          {feedItems.map((item) => {
            const right = item.id % 2 === 0;
            return (
              <div
                key={item.id}
                className={`relative mb-6 flex flex-col gap-3 pl-14 md:pl-0 ${
                  right ? "md:flex-row md:justify-end" : "md:flex-row"
                }`}
              >
                <span
                  className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-background-50 ring-1 ring-background-200 md:left-1/2 md:-translate-x-1/2"
                >
                  <i className={`${iconOf(item.phase)} text-lg text-primary-500`}></i>
                </span>
                <div
                  className={`w-full md:w-[46%] ${
                    right ? "md:pr-10 md:text-right" : "md:pl-10"
                  }`}
                >
                  <div
                    className={`rounded-2xl bg-background-100 p-4 ring-1 ring-background-200 md:p-5 ${
                      right ? "md:text-left" : ""
                    }`}
                  >
                    <div
                      className={`flex flex-wrap items-center gap-2 ${
                        right ? "md:flex-row-reverse" : ""
                      }`}
                    >
                      <span
                        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs ${colorOf(
                          item.phase
                        )}`}
                      >
                        <i className={`${iconOf(item.phase)} text-sm`}></i>
                        {item.phase}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <h3 className="mt-3 text-sm font-semibold text-foreground-900 md:text-base">
                      <span className="mr-2 rounded-md bg-background-200 px-2 py-0.5 text-xs text-foreground-600">
                        {item.tag}
                      </span>
                      {item.title}
                    </h3>
                    <p className="mt-2 text-xs text-foreground-500">{item.digest}</p>
                    <div className={`mt-3 flex items-center gap-1.5 text-xs text-foreground-400 ${right ? "md:flex-row-reverse" : ""}`}>
                      <i className="ri-eye-line"></i>
                      {item.views} 人已读
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}